import { musicPlatform } from 'fitbeat.gym-core/config';
import { UserProfile } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { IAppStore } from '../../reducer';
import { orientationSelector } from '../../selectors';
import { DeviceSetupSubScreenHeader } from '../DeviceSetup/DeviceSetupSubScreenHeader';
import { backFromMusicSourceSelectScreenPressed, musicSourceSelected } from './actions';
import { SelectMusicSourceButtons } from './SelectMusicSourceButtons';
import {
  authenticationFailedMessageSelector,
  getAuthenticationFailedSelector,
} from './selectors';
import { WarningMessage } from './WarningMessage';

interface IProps {
  musicSourceSelected: (source: musicPlatform) => void;
  orientation: string;
  spotifyAuthenticationFailed: boolean;
  userProfile: any;
  t: (key: string) => any;
  spotifyAuthenticationFailedMessage?: string;
  backPressed: () => void;
}

export const musicSourceIcons = {
  generic: require('../../../assets/images/generic-playlist.png'),
};

const SelectMusicSourceScreenComponent: FunctionComponent<IProps> = ({ t, backPressed, ...props }) => {

  const portrait = () => {
    return props.orientation === 'PORTRAIT';
  };

  const authMessage = props.spotifyAuthenticationFailedMessage
    ? props.spotifyAuthenticationFailedMessage
    : 'Failed to connect to spotify';
  const isAlphaFeatureUser = UserProfile.isFeatureEnabledForUser('alpha', props.userProfile);

  return (
    <>
      <DeviceSetupSubScreenHeader title={t('music')} onBackPress={backPressed} />
      <View style={[styles.container, !portrait() && { justifyContent: 'center' }]}>
        <Text style={[styles.heading, portrait() && styles.headingPortrait]}>{t('selectMusicPlayer')}</Text>
        {
          props.spotifyAuthenticationFailed &&
          <View style={styles.errorContainer}>
            <WarningMessage message={authMessage} style={{ paddingBottom: 12 }} />
          </View>
        }
        <SelectMusicSourceButtons isAlphaFeatureUser={isAlphaFeatureUser} showSelectGeneric={true} t={t} />
      </View>
    </>
  );
};

const mapStateToProps = (state: IAppStore): Partial<IProps> => ({
  orientation: orientationSelector(state),
  spotifyAuthenticationFailed: getAuthenticationFailedSelector(state),
  spotifyAuthenticationFailedMessage: authenticationFailedMessageSelector(state),
  userProfile: state.homeWorkouts.userProfile,
});

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    musicSourceSelected: (musicSource) => dispatch(musicSourceSelected(musicSource)),
    backPressed: () => dispatch(backFromMusicSourceSelectScreenPressed()),
  };
};

export const SelectMusicSourceScreen = connect(mapStateToProps, mapDispatchToProps)
(translate(['homeWorkouts'], { wait: true })(SelectMusicSourceScreenComponent));

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
  },
  heading: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
    marginBottom: defaultScale(20),
  },
  headingPortrait: {
    marginVertical: defaultScale(30),
  },
  errorContainer: {
    paddingLeft: defaultScale(50),
    paddingRight: defaultScale(50),
  },
});
